import "./styles.css";
import React from "react";
import Checkbox from "@mui/material/Checkbox";
import CachedIcon from "@mui/icons-material/Cached";
import { SvgIcon } from "@mui/material";
import RecurringEvent from "./recurring-event";

export default function RecurringItem({
  checked,
  onChecked,
  repeatWeek,
  onRepeatChange,
  daysSelected,
  onDaysSelected,
}) {
  return (
    <>
      <div
        className="check-box"
        style={{ border: "1px solid rgba(169,169,169)" }}
        id="recurring-item-container"
      >
        <Checkbox
          checked={checked}
          onChange={onChecked}
          inputProps={{ "aria-label": "controlled" }}
          id="recurring-item-check-box"
        />
        <div className="timing" id="recurring-item-title-container">
          <SvgIcon
            component={CachedIcon}
            sx={{ color: "green" }}
            id="recurring-item-icon"
          />
          <p id="recurring-item-title">Recurring event</p>
        </div>
      </div>
      {checked && (
        <RecurringEvent
          repeatWeek={repeatWeek}
          onRepeatChange={onRepeatChange}
          daysSelected={daysSelected}
          onDaysSelected={(name, checked) => onDaysSelected(name, checked)}
          id="recurring-event"
        />
      )}
    </>
  );
}
